// extracted by mini-css-extract-plugin
module.exports = {"errorWidgetWrap":"styles_errorWidgetWrap__txEci","title":"styles_title__rlO0r","content":"styles_content__KLAlf","actionBtn":"styles_actionBtn__58Nw9"};